import { Grid, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getCargos, getResponsables, newResponsable } from "../../../../redux/actions/empleador";
import ConfirmDialog from "../../../commons/dialog/ConfirmDialog";
import FormikActions from "../../../commons/formik/FormikActions";
import FormikTextField from "../../../commons/formik/FormikTextField";
import NewResponsableDialog from "../../../commons/responsables/dialog/NewResponsableDialog";
import ResponsablesCard from "../../../commons/responsables/responsablesCard/ResponsablesCard";
import ResponsablesEnum from "../../../enums/responsablesEnum";
import { StyledNuevaObra } from "../../../styled/Obras";
import { validateResponsables } from "./validateResponsables";

const ResponsablesObraForm = ({ handleSubmitLastForm, formModel, handleCancel }) => {
  const dispatch = useDispatch();
  const postTipoDeObra = useSelector((state) => state.obra.postTipoDeObra);

  const [responsableName, setResponsableName] = useState();
  const [responsableType, setResponsableType] = useState(null);
  const [responsablesDialogOpen, setResponsablesDialogOpen] = useState(false);
  const [openClearContactDialog, setOpenClearContactDialog] = useState(false);

  const handleCloseResponsableDialog = () => {
    setResponsablesDialogOpen(false);
  }
  const handleAddResponsable = (values, setFieldValue) => {

    dispatch(newResponsable(values)).then((resp) => {
      toast.success("Responsable agregado correctamente");
      dispatch(getResponsables(responsableType)).then((res) => {
        let objAux = {
          id: res.value.data[res.value.data.length - 1].id,
          nombre: res.value.data[res.value.data.length - 1].nombre,
        };
        setFieldValue(responsableName, objAux.id);
      });
      setResponsablesDialogOpen(false);
    });
  };

  const handleOpenAddResponsable = (name, responsableType) => {
    setResponsableName(name);
    setResponsableType(responsableType);
    dispatch(getCargos(responsableType));
    setResponsablesDialogOpen(true);
  }

  return (
    <Formik
      initialValues={formModel}
      enableReinitialize={true}
      onSubmit={handleSubmitLastForm}
      validationSchema={validateResponsables}
    >
      {({ values, setFieldValue, }) => (
        <Form>
          <Grid container spacing={3}>
            <StyledNuevaObra.PaddingContainer
              item
              xs={12}
            >
              <ResponsablesCard
                name="responsableEmpleador"
                title="Responsable del Empleador"
                handleOpenAddResponsable={handleOpenAddResponsable}
                fieldLabel="Responsable del Empleador"
                responsableType={ResponsablesEnum.representanteEmpleador}
              />

            </StyledNuevaObra.PaddingContainer>
            <StyledNuevaObra.PaddingContainer
              item
              xs={12}
            >
              <ResponsablesCard
                required
                name="responsableSeguridadHigiene"
                title="Responsable de Seguridad e Higiene"
                handleOpenAddResponsable={handleOpenAddResponsable}
                fieldLabel="Responsable de S y H"
                responsableType={ResponsablesEnum.seguridadHigiene}
              />

            </StyledNuevaObra.PaddingContainer>
            <Grid
              item
              xs={12}
            >
              <StyledNuevaObra.PaddingContainer>
                <Typography variant="h6">
                  Contacto en la Obra
                </Typography>
                <StyledNuevaObra.PaddingContainer
                  item
                  container
                  xs={12}
                  spacing={3}
                >
                  <Grid
                    item
                    xs={3}
                  >
                    <FormikTextField
                      name="nombreApellidoContacto"
                      label="Nombre y Apellido"
                      fullWidth
                      onChange={(e) => {
                        if (e.target.value === "") {
                          const hasContactData = Boolean(
                            values.dniContacto || values.telefonoContacto || values.mailContacto
                          );

                          if (hasContactData) {
                            setOpenClearContactDialog(true);
                            return;
                          }

                          setFieldValue("dniContacto", "");
                          setFieldValue("telefonoContacto", "");
                          setFieldValue("mailContacto", "");
                        }
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={3}
                  >
                    <FormikTextField
                      disabled={!values.nombreApellidoContacto}
                      name="dniContacto"
                      label="DNI"
                      fullWidth
                    />
                  </Grid>
                  <Grid
                    item
                    xs={3}
                  >
                    <FormikTextField
                      disabled={!values.nombreApellidoContacto}
                      name="telefonoContacto"
                      label="Teléfono"
                      fullWidth
                    />
                  </Grid>
                  <Grid
                    item
                    xs={3}
                  >
                    <FormikTextField
                      disabled={!values.nombreApellidoContacto}
                      name="mailContacto"
                      label="Mail"
                      fullWidth
                    />
                  </Grid>
                </StyledNuevaObra.PaddingContainer>
              </StyledNuevaObra.PaddingContainer>
            </Grid>
          </Grid>

          <StyledNuevaObra.ButtonContainer>
            <FormikActions
              loading={postTipoDeObra.loading}
              handleCancel={handleCancel}
              submit="Finalizar"
            />
            <NewResponsableDialog
              open={responsablesDialogOpen}
              handleSubmit={(values) => handleAddResponsable(values, setFieldValue)}
              handleClose={handleCloseResponsableDialog}
            />
            <ConfirmDialog
              open={openClearContactDialog}
              handleClose={() => {
                setOpenClearContactDialog(false);
              }}
              handleConfirm={() => {
                setFieldValue("nombreApellidoContacto", "");
                setFieldValue("dniContacto", "");
                setFieldValue("telefonoContacto", "");
                setFieldValue("mailContacto", "");
                setOpenClearContactDialog(false);
              }}
              loading={false}
              title="Eliminar contacto"
              text="Si borra el nombre del contacto, también se eliminarían DNI, teléfono y mail."
              warningText="¿Desea continuar?"
            />
          </StyledNuevaObra.ButtonContainer>
        </Form>
      )
      }
    </Formik >
  )
}

export default ResponsablesObraForm;